import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/logo.svg'


const _hoisted_1 = { class: "hero is-fullheight has-width-100" }
const _hoisted_2 = { class: "hero-body is-centered" }
const _hoisted_3 = { class: "login" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"columns is-vcentered\"><div class=\"column is-one-third logo\"><img alt=\"logo\" src=\"" + _imports_0 + "\"></div><div class=\"column\"><h1 class=\"title is-4 has-text-weight-medium has-text-left\">Annotator</h1></div></div>", 1)
const _hoisted_5 = { class: "field" }
const _hoisted_6 = {
  for: "login-input",
  class: "label"
}
const _hoisted_7 = { class: "control has-icons-left" }
const _hoisted_8 = { class: "icon is-small is-left" }
const _hoisted_9 = { class: "field" }
const _hoisted_10 = {
  for: "password-input",
  class: "label"
}
const _hoisted_11 = { class: "control has-icons-left" }
const _hoisted_12 = { class: "icon is-small is-left" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "level" }
const _hoisted_15 = { class: "level-item has-text-centered" }
const _hoisted_16 = {
  class: "has-text-grey-light is-hidden",
  href: "#"
}
const _hoisted_17 = {
  class: "button is-block is-fullwidth is-primary is-medium",
  type: "submit"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_customFooter = _resolveComponent("customFooter")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("form", {
          ref: "loginForm",
          class: "form-signin",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('login.email')), 1),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                id: "login-input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                class: "input is-medium",
                type: "email"
              }, null, 512), [
                [_vModelText, _ctx.email]
              ]),
              _createElementVNode("span", _hoisted_8, [
                _createVNode(_component_font_awesome_icon, { icon: "envelope" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('login.password')), 1),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                id: "password-input",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                class: "input is-medium",
                type: "password"
              }, null, 512), [
                [_vModelText, _ctx.password]
              ]),
              _createElementVNode("span", _hoisted_12, [
                _createVNode(_component_font_awesome_icon, { icon: "lock" })
              ])
            ])
          ]),
          _hoisted_13,
          _createElementVNode("nav", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", null, [
                _createElementVNode("a", _hoisted_16, _toDisplayString(_ctx.$t('login.forgotPassword')), 1)
              ])
            ])
          ]),
          _createElementVNode("button", _hoisted_17, _toDisplayString(_ctx.$t('login.login')), 1)
        ], 544),
        _hoisted_18
      ])
    ]),
    _createVNode(_component_customFooter)
  ]))
}